import { render } from "./PasswordCreated.vue?vue&type=template&id=0f6a694c"
import script from "./PasswordCreated.vue?vue&type=script&lang=js"
export * from "./PasswordCreated.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__